const hatchPatternMapping = (data) => {
  return data
    ? data.map((item) => ({
        laser_profile_id: item.laser_profile_id,
        hatch_type: item.hatch_type,
        hatch_style: item.hatch_style,
        is_apply_smoothing: item.is_apply_smoothing,
        border_gap: Number(item.border_gap),
        with_offset: item.with_offset,
        border_gap_direction: item.border_gap_direction,
        corner_style: item.corner_style,
        line_gap: Number(item.line_gap),
        line_angle: Number(item.line_angle),
        base: {
          x: Number(item.base_x),
          y: Number(item.base_y),
        },
        individual_hatch_line_repeat_count: Number(item.individual_hatch_line_repeat_count),
        is_incremental_rotation_enabled: item.is_incremental_rotation_enabled,
        incremental_start_angle: Number(item.incremental_start_angle),
        incremental_step_angle: Number(item.incremental_step_angle),
        incremental_step_count: Number(item.incremental_step_count),
        id: item.id,
      }))
    : []
}
export default hatchPatternMapping
